// extracted by mini-css-extract-plugin
export var articleTableOfContents = "articleTableOfContents-module--articleTableOfContents--c64f0";
export var chevron = "articleTableOfContents-module--chevron--708d8";
export var headerContainer = "articleTableOfContents-module--headerContainer--cc60e";
export var heading = "articleTableOfContents-module--heading--2dd19";
export var linkListItem = "articleTableOfContents-module--linkListItem--82c0c";
export var sectionLinkList = "articleTableOfContents-module--sectionLinkList--ab0ac";
export var sectionLinkToc = "articleTableOfContents-module--sectionLinkToc--77e17";
export var sectionName = "articleTableOfContents-module--sectionName--ae058";